import useSWR from "swr"

import {
    AppError,
    parseAndThrowAppError,
} from "../../../../errors/errorProcessors"
import {
    badRequestError,
    invalidApiDataError,
} from "../../../../errors/recognisedErrors"
import { getClientProtected } from "../../clients/clients"
import { manufacturerHomepageMapper } from "../../mappers/manufacturerInterface/manufacturerHomepageMapper"
import { IManufacturerDevicesData } from "../../types/manufacturerInterface/manufacturerHomepageTypes"
import { MANU_REPORTING } from "../../urls/private"

interface IManufacturerHomepageData {
    data: IManufacturerDevicesData | undefined
    error: AppError | null
    isLoading: boolean
}
/**
 * Hook to get the manufacturer homepage data
 * @returns The manufacturer homepage data
 */
const useGetManufacturerHomepageData = (): IManufacturerHomepageData => {
    const { data, error, isLoading } = useSWR(
        MANU_REPORTING,
        async (url: string): Promise<IManufacturerDevicesData> => {
            try {
                const res = await getClientProtected(url)
                return manufacturerHomepageMapper.mapManufacturerDevicesData(
                    res
                )
            } catch (err) {
                badRequestError("Failed to load KPI's")
                const appError = parseAndThrowAppError(err)
                throw invalidApiDataError(appError.message)
            }
        }
    )
    return {
        data,
        error,
        isLoading,
    }
}

export { useGetManufacturerHomepageData }
